import Rete from 'rete'
import { App } from '../../App'
import { nanoid } from 'nanoid/async'
import CONST_SOCKET from '../../const/socket'
import { buttonModal } from './buttonModal'
import {
  removeNodes,
  updateNodeConnections,
  addNewSequenceToEditor,
  addNewSequenceSingleToEditor,  
  fixYPositionOfChildComponents,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {

  const oldData = node.data
  const { 
    value: buttonData,
    isConfirmed: isClickedOkButton,
  } = await buttonModal(oldData, node)

  // hide output socket section except button type is newPostback
  const nodeClass = '.node-id-' + node.id
  const parentElement1 = $(nodeClass).find('[title=' + CONST_SOCKET.BUTTON_OUTPUT + ']').parent()
  const parentElement2 = $(nodeClass).find('[title=' + CONST_SOCKET.BUTTON_OUTPUT_SEQUENCE + ']').parent()
  if(buttonData.buttonType !== 'new_post_back')
  {
    var hasConnections = []
    hasConnections = node.outputs.get(CONST_SOCKET.BUTTON_OUTPUT).connections.slice()
    if (hasConnections.length > 0) {
      hasConnections.forEach(singleConnection => {
        editor.removeConnection(singleConnection)
      })
    }
    hasConnections = node.outputs.get(CONST_SOCKET.BUTTON_OUTPUT_SEQUENCE).connections.slice()
    if (hasConnections.length > 0) {
      hasConnections.forEach(singleConnection => {
        editor.removeConnection(singleConnection)
      })
    }
    
    setTimeout(function() {
      parentElement1.addClass('d-none').removeClass('d-block')
      parentElement2.addClass('d-none').removeClass('d-block')
    }, 500);
  }
  else
  {
    parentElement1.removeClass('d-none').addClass('d-block')
    parentElement2.removeClass('d-none').addClass('d-block')
  }

  if (buttonData && Object.values(buttonData).length > 0) {
    // Create text unique ID if there is not any
    if (! ('postbackId' in node.data)) {
      node.data.postbackId = await nanoid(15)
    }

    Object.assign(node.data, buttonData)
    
    if ('new_post_back' === buttonData.buttonType) {
      if (! ('newPostbackId' in node.data)) {
        node.data.newPostbackId = await nanoid(15)
      }
    }

    if ('newSequence' === buttonData.sequenceIdValue) {
      node.buttonNodeSequenceSocketStatus = false
      if (node.outputs instanceof Map) {
        const buttonOutputSequence = node.outputs.get(CONST_SOCKET.BUTTON_OUTPUT_SEQUENCE)
        if (buttonOutputSequence instanceof Rete.Output) {
          if (0 === buttonOutputSequence.connections.length) {
            attachNewSequenceAndChildrenToButtonNode(node)
          }
        }
      }
    }

    if ('newSequence' !== buttonData.sequenceIdValue) {
      node.buttonNodeSequenceSocketStatus = true
      if (isClickedOkButton && node.buttonNodeSequenceSocketStatus) {
        if (node.buttonNodeChildrenComponents 
          && node.buttonNodeChildrenComponents instanceof Map
        ) {
          const nodesList = node.buttonNodeChildrenComponents.get('node-id-' + node.id)
          
          if (nodesList) {
            removeNodes(nodesList)
            node.buttonNodeChildrenComponents.delete('node-id-' + node.id)
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)

  }

  return false
}

const attachNewSequenceAndChildrenToButtonNode = async (node) => {
  const newSequenceNodePosition = [node.position[0] + 320, node.position[1] + 40]
  const newSequenceNode = await addNewSequenceToEditor(newSequenceNodePosition)

  const nodeList = [newSequenceNode]

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.BUTTON_OUTPUT_SEQUENCE),
    newSequenceNode.inputs.get(CONST_SOCKET.SEQUENCE_INPUT)
  )

  const items = [1, 2, 3]
  
  // eslint-disable-next-line
  items.map(async (item, index) => { 
    const sequenceSingleNodePositionY = fixYPositionOfChildComponents(index, 160, items.length)
    const squenceSingleNodePosition = [node.position[0] + 650, sequenceSingleNodePositionY]
    const sequenceSingleNode = await addNewSequenceSingleToEditor(squenceSingleNodePosition)

    nodeList.push(sequenceSingleNode)

    App.editor.connect(
      newSequenceNode.outputs.get(CONST_SOCKET.SEQUENCE_OUTPUT),
      sequenceSingleNode.inputs.get(CONST_SOCKET.SEQUENCE_SINGLE_INPUT)
    )

  })

  const componentsMap = new Map()
  componentsMap.set('node-id-' + node.id, nodeList)
  node.buttonNodeChildrenComponents = componentsMap
}